// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__0BZVo","footerContent":"footer_footerContent__JS-5A","footerCopy":"footer_footerCopy__dDvJu"};